import React from 'react';
import styled from 'styled-components';
import LightButton from '~/editor/buttons/LightButton';

import DoneIcon from '~/assets/icons/done2.svg';
import XIcon from '~/assets/icons/x.svg';

export const DoneBtnIcon = styled(DoneIcon)``;
export const XBtnIcon = styled(XIcon)``;

const Wrapper = styled.div`
  display: flex;

  button {
    padding: 5px;
    width: 38px;
    height: 38px;

    svg {
      margin-left: 7px;
    }

    &.active svg {
      path {
        fill: #FFF;
      }
    }
  }

  button:first-child {
    border-radius: 5px 0 0 5px;
  }

  button:last-child {
    border-radius: 0 5px 5px 0;
  }
`;

export const Switcher = ({value, onChange}: {value: string, onChange: (value: string) => void}) => {
  return <Wrapper>
    <LightButton className={value === 'true' ? 'active' : ''} onClick={() => onChange('true')}>
      <DoneBtnIcon />
    </LightButton>
    <LightButton className={value === 'false' ? 'active' : ''} onClick={() => onChange('false')}>
      <XBtnIcon />
    </LightButton>
  </Wrapper>
}
